import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import RadarPage from "@/pages/RadarPage";
import PesquisaPage from "@/pages/PesquisaPage";
import ContatoPage from "@/pages/ContatoPage";
import PublicacoesPage from "@/pages/PublicacoesPage";
import DocenciaPage from "@/pages/DocenciaPage";
import SobrePage from "@/pages/SobrePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/radar" element={<RadarPage />} />
                    <Route path="/pesquisa" element={<PesquisaPage />} />
                    <Route path="/publicacoes" element={<PublicacoesPage />} />
                    <Route path="/docencia" element={<DocenciaPage />} />
                    <Route path="/sobre" element={<SobrePage />} />
                    <Route path="/contato" element={<ContatoPage />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
